export enum StatisticsType {
  DOMAINS = 'domains',
  SENDINGS = 'sendings',
}
